import MidwaySportsBuy1Get1FreeButton from './midwaysports-buy-1-get-1-free-button'

Vue.component(MidwaySportsBuy1Get1FreeButton.name, MidwaySportsBuy1Get1FreeButton)

export default {
  MidwaySportsBuy1Get1FreeButton,
}
